import {Component, Inject, ViewChild, ElementRef, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
// import { HomepageComponent } from '../homepage/homepage.component';

@Component({
  selector: 'app-dialogbox',
  templateUrl: './dialogbox.component.html',
  styleUrls: ['./dialogbox.component.css']
})
export class DialogboxComponent implements OnInit {
  @ViewChild('myDiv1',{static: false}) myDiv1: ElementRef;
  @ViewChild('myDiv2',{static: false}) myDiv2: ElementRef;
  result1:any;
  result2:any;

  constructor(
    public dialogRef: MatDialogRef<DialogboxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      dialogRef.disableClose = true;
    }
    ngOnInit(){
      this.result1 = this.data.d1;
      this.result2 = this.data.d2
    }

  onNoClick(): void {
    alert(JSON.stringify(this.data))
    this.dialogRef.close();
  }

}
